module.exports = __webpack_public_path__ + "static/media/HP_card_walnut_place.03f9a6a3.jpg";